import SimpleStorage from './simpleStorage';
import productManagementService from '../services/productManagementService';

/** Max services + products combined that can appear in the embeddable website widget. */
export const MAX_WIDGET_FEATURED_SLOTS = 6;

export type WidgetFeaturedUsage = {
  used: number;
  serviceFeatured: number;
  productFeatured: number;
};

/**
 * Count how many active items are marked featured for the widget (services + products).
 */
export async function getWidgetFeaturedUsage(businessOwnerId: string): Promise<WidgetFeaturedUsage> {
  await SimpleStorage.forceInitialize();
  const raw = await SimpleStorage.getItem(`services_${businessOwnerId}`);
  let svcList: any[] = [];
  if (raw) {
    try {
      svcList = JSON.parse(raw);
    } catch {
      svcList = [];
    }
  }
  const serviceFeatured = svcList.filter(
    (s: any) => s && s.featuredOnWidget === true && s.isActive !== false
  ).length;

  let products: any[] = [];
  try {
    products = await productManagementService.loadProducts(businessOwnerId);
  } catch {
    products = [];
  }
  const productFeatured = products.filter(
    (p: any) => p && p.featuredOnWidget === true && p.isActive !== false
  ).length;

  return {
    used: serviceFeatured + productFeatured,
    serviceFeatured,
    productFeatured,
  };
}
